// import * as React from "react";
// import { AppBar, Toolbar, IconButton, Stack, Typography } from "@mui/material";
// import Profile from "./Profile";
// import Tooltip from "@mui/material/Tooltip";
// import CurrentDate from "./CurrentDate";
// import LightDarkSwitch from "./light_dark_switch";
// import Notifications from "./Notifications";
// import { Link } from "react-router-dom";
// import logo from "./../../../images/logo.png";
// import logo_dark from "./../../../images/logo_dark.png";
// const TopNavbar = ({
//   toogleActive,
//   active,
//   darkMode,
//   setDarkMode,
//   showToolTip,
// }) => {
//   console.log(darkMode  ,"dsfsdfdssdfs")
//   return (
//     <>
//       <AppBar
//         color="inherit"
//         sx={{
//           backgroundColor: "#fff",
//           boxShadow: "0px 4px 20px rgba(47, 143, 232, 0.07)",
//           py: "6px",
//           mb: "15px",
//           position: "sticky",
//         }}
//         className="top-navbar-for-dark"
//       >
//         <Toolbar>
//           {active && (
//             <Link to="/Dashboard" style={{ marginRight: "2rem" }}>
//               <img
//                 src={ darkMode ?logo_dark: logo}
//                 alt="Logo"
//                 // src={seven_logo} alt="Logo"

//                 // height={"90rem"}
//                 width={"90px"}
//               />
//             </Link>
//           )}
//           {showToolTip && (
//             <Tooltip title="Hide/Show" arrow>
//               <IconButton
//                 size="sm"
//                 edge="start"
//                 color="inherit"
//                 onClick={toogleActive}
//               >
//                 <svg
//                   style={{ height: "1rem" }}
//                   xmlns="http://www.w3.org/2000/svg"
//                   viewBox="0 0 448 512"
//                 >
//                   <path
//                     fill="var(--themeFontColor)"
//                     d="M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"
//                   />
//                 </svg>
//               </IconButton>
//             </Tooltip>
//           )}

//           <Typography component="div" sx={{ flexGrow: 1 }}></Typography>

//           <Stack direction="row" spacing={2}>
//             <LightDarkSwitch darkMode={darkMode} setDarkMode={setDarkMode} />
//             {/* <CurrentDate /> */}

//             <Notifications />

//             <Profile  darkMode={darkMode} setDarkMode={setDarkMode}/>
//           </Stack>
//         </Toolbar>
//       </AppBar>
//     </>
//   );
// };

// export default TopNavbar;
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Menu, X, Sun, Moon } from "lucide-react";
import Profile from "./Profile";
import Notifications from "./Notifications";
import logo from "./../../../images/logo.png";
import logo_dark from "./../../../images/logo_dark.png";
import LightDarkSwitch from "./light_dark_switch";
import PromotionVideo from "./PromotionVideo";

const TopNavbar = ({
  toggleActive,
  active,
  darkMode,
  setDarkMode,
  showToolTip,
}) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <nav className={`
      sticky top-0 z-40 w-full border-b backdrop-blur-lg
      ${darkMode 
        ? 'bg-gray-900/95 border-gray-700/50' 
        : 'bg-white/95 border-gray-200/50'
      }
    `}>
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Left Section */}
          <div className="flex items-center gap-4">
            {/* Mobile Menu Button */}
            {showToolTip && (
              <button
                onClick={toggleActive}
                className={`
                  p-2 rounded-lg transition-all duration-200 lg:hidden
                  ${darkMode
                    ? 'hover:bg-gray-800 text-gray-300 hover:text-white'
                    : 'hover:bg-gray-100 text-gray-600 hover:text-gray-900'
                  }
                `}
                aria-label="Toggle sidebar"
              >
                {active ? <X size={20} /> : <Menu size={20} />}
              </button>
            )}

            {/* Logo */}
            {active && (
              <Link 
                to="/dashboard" 
                className="flex items-center gap-3 group"
              >
                <div className="relative">
                  <img
                    src={logo}
                    alt="Logo"
                    className="w-auto transition-transform duration-200 group-hover:scale-105"
                    style={{height : "9rem"}}
                  />
                </div>
                {/* {!isMobile && (
                  <span className={`
                    font-bold text-xl transition-colors duration-200
                    ${darkMode ? 'text-white' : 'text-gray-900'}
                    group-hover:text-blue-500
                  `}>
                    Dashboard
                  </span>
                )} */}
              </Link>
            )}
          </div>

          {/* Right Section */}
          <div className="flex items-center gap-2">
            {/* Theme Toggle */}
            {/* <button
              onClick={() => setDarkMode(!darkMode)}
              className={`
                p-2 rounded-lg transition-all duration-200
                ${darkMode
                  ? 'hover:bg-gray-800 text-gray-300 hover:text-yellow-400'
                  : 'hover:bg-gray-100 text-gray-600 hover:text-blue-500'
                }
              `}
              aria-label="Toggle theme"
            >
              {darkMode ? <Sun size={20} /> : <Moon size={20} />}
            </button> */}
            <PromotionVideo />
               <LightDarkSwitch darkMode={darkMode} setDarkMode={setDarkMode} />

            {/* Notifications */}
            <Notifications darkMode={darkMode} />

            {/* Profile */}
            <Profile darkMode={darkMode} setDarkMode={setDarkMode} />
          </div>
        </div>
      </div>
    </nav>
  );
};

export default TopNavbar;
